import "@fontsource/rubik/400.css";
import "@fontsource/rubik/500.css";
import "@fontsource/rubik/600.css";
import "@fontsource/rubik/700.css";
import "@fontsource/rubik/800.css";
import "@fontsource/inter"; // defaults to 400
import "@fontsource/inter/700.css";
import "@fontsource/inter/800.css";
import "@fontsource/inter/900.css";

if (typeof global === "undefined") {
  (window as any).global = window;
}

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./styles/global.css";
import { installVisualViewportPin } from "./lib/visualViewportPin";

// Must run before React's first paint so `--vvh` / `--vv-offset-top` already have values
// when `.appFlowWrapper` mounts; otherwise the shell briefly falls back to `100dvh` and
// can render under the on-screen keyboard during the first frame on iOS Safari.
installVisualViewportPin();
import { initI18n } from "../../../packages/ui/src/i18n/i18n";

void initI18n().then(() => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
